import keyBy from 'lodash/keyBy'

const setMembers = (state, members) => {
  Object.assign(state, {
    all: { ...state.all, ...keyBy(members, 'id') }
  })
}

const setMember = (state, member) => {
  Object.assign(state, {
    all: {
      ...state.all,
      [member.id]: member
    }
  })
}

const updateMemberPhoto = (state, { id, photoURL }) => {
  state.all[id] = {
    ...state.all[id],
    photoURL
  }
}

export default {
  setMembers,
  setMember,
  updateMemberPhoto
}
